"use strict";
/**
 * Created by Razmik.Mkrtchyan on 9/24/2016.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-error.component.css");
var ValidationErrorMessage = /** @class */ (function () {
    function ValidationErrorMessage() {
        this.errorClass = 'sis-error-container';
    }
    Object.defineProperty(ValidationErrorMessage.prototype, "errorMessage", {
        get: function () {
            return this._errorMessage;
        },
        set: function (errorMessage) {
            this._errorMessage = errorMessage;
            this._errorMessage && this.forControl.classList.add(this.errorClass);
            !this._errorMessage && this.forControl.classList.contains(this.errorClass) && this.forControl.classList.remove(this.errorClass);
        },
        enumerable: true,
        configurable: true
    });
    ValidationErrorMessage.prototype.hasError = function () {
        return !!this._errorMessage;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ValidationErrorMessage.prototype, "id", void 0);
    __decorate([
        core_1.Input('errorMessage'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ValidationErrorMessage.prototype, "errorMessage", null);
    ValidationErrorMessage = __decorate([
        core_1.Component({
            
            selector: 'sis-error',
            template: require('./sis-error.component.html'),
            inputs: ['id', 'forControl', 'errorClass', 'isInput']
        })
        /**
         * ValidationErrorMessage component for showing/hiding error messages
         * inputs: ['id', '_errorMessage', 'forControl', 'errorClass']
         * @id:string -id of component
         * @_errorMessage:string -message which should show
         * @forControl:( template reference type variable) -control for which must show message
         * @errorClass:string -class name which you want to add to @forControl on case of invalid data
         * Also on case of @isInput==true component added onfocus,onblur,onmouseover,onmouseout events to @forControl for
         * showing/hiding error message
         */
        ,
        __metadata("design:paramtypes", [])
    ], ValidationErrorMessage);
    return ValidationErrorMessage;
}());
exports.ValidationErrorMessage = ValidationErrorMessage;
//# sourceMappingURL=sis-error.component.js.map